import { render, staticRenderFns } from "./signUpPC.vue?vue&type=template&id=b2cfe6f4&scoped=true"
import script from "./signUpPC.vue?vue&type=script&lang=js"
export * from "./signUpPC.vue?vue&type=script&lang=js"
import style0 from "./signUpPC.vue?vue&type=style&index=0&id=b2cfe6f4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cfe6f4",
  null
  
)

export default component.exports